// Angular imports
import { Component, EventEmitter, Injector, Input, OnInit, Output } from '@angular/core';

// 3rd party imports
import { Observable } from 'rxjs';

// CC-Common imports
import { Utils } from 'cc-common';

// Dev-extream imports
import notify from 'devextreme/ui/notify';

// Constant imports
import { MessageInterval } from '../../../_constants/messages-intervals';
import { BoardApprovalProcessConstants } from '../../../shared-acc-board-approval-module/_constants/board-approval-process-constants';

// Component imports
import { BoardApprovalBaseComponent } from '../../_base/board-approval-base.component';

// Model imports
import { BaseProcessNotesResultDto } from '../../../management-common/_models/notes/base-process-notes-result-dto';
import { BoardApprovalAddNotesParameterDto } from '../../../shared-acc-board-approval-module/_models/board-approval-add-notes-parameter-dto';
import { BoardApprovalItemResultDto } from '../../../shared-acc-board-approval-module/_models/board-approval-item-result-dto';
import { BoardApprovalNotesEditorParameterDto } from '../../../shared-acc-board-approval-module/_models/board-approval-notes-editor-parameter-dto';

@Component({
    selector: 'app-board-approval-grid-notes-editor',
    templateUrl: './board-approval-grid-notes-editor.component.html',
    styleUrls: ['./board-approval-grid-notes-editor.component.scss']
})
export class BoardApprovalGridNotesEditorComponent extends BoardApprovalBaseComponent implements OnInit {
    @Input() visible = false;
    @Input() isClosed: boolean;
    @Input() selectedRequest: BoardApprovalItemResultDto;
    @Output() onNotesEditorClose = new EventEmitter<boolean>();

    previousNotes: string;
    loadingVisible = false;
    allowNewNotes = false;
    isNotesSaved = false;
    popupTitle = '';

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        if (Utils.notNullAndDefined(this.selectedRequest)) {
            this.popupTitle = this.selectedRequest.processIdDisplayText;
            this.populateBoardApprovalNotes(true);
        }
    }

    onNotesPopClose(): void {
        this.previousNotes = null;
        this.visible = false;
        this.onNotesEditorClose.emit(this.isNotesSaved);
    }

    onSaveNotes(event: string): void {
        this.saveBoardApprovalNotes(event);
    }

    private saveBoardApprovalNotes(note: string): void {
        const param: BoardApprovalAddNotesParameterDto = new BoardApprovalAddNotesParameterDto();
        param.communityId = this.selectedRequest.communityId;
        param.processId = this.selectedRequest.processId;
        param.isOpen = Utils.isFalse(this.isClosed);
        param.note = note;
        param.action = this.selectedRequest.action;
        param.clearCache = true;

        let service: Observable<any>;
        if (Utils.equalsIgnoreCase(this.selectedRequest.process, BoardApprovalProcessConstants.ACC)) {
            service = this.sharedBoardApprovalService.saveNotesForAcc(param);
        } else if (Utils.equalsIgnoreCase(this.selectedRequest.process, BoardApprovalProcessConstants.COLLECTIONS)) {
            service = this.sharedBoardApprovalService.saveNotesForCollections(param);
        } else if (Utils.equalsIgnoreCase(this.selectedRequest.process, BoardApprovalProcessConstants.WF)) {
            service = this.sharedBoardApprovalService.saveNotesForWorkflow(param);
        }
        this.loadingVisible = true;
        service.subscribe(
            () => {
                notify(
                    `Board approval notes for process ${this.selectedRequest.process} successfully saved.`,
                    'success',
                    MessageInterval.successMsgInterval
                );
                this.isNotesSaved = true;
                this.onNotesPopClose();
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
            }
        );
    }

    private populateBoardApprovalNotes(clearCache = false): void {
        const param: BoardApprovalNotesEditorParameterDto = new BoardApprovalNotesEditorParameterDto();
        param.communityId = this.selectedRequest.communityId;
        param.processId = this.selectedRequest.processId;
        param.isOpen = Utils.isFalse(this.isClosed);
        param.clearCache = clearCache;
        param.action = this.selectedRequest.action;
        let service: Observable<any>;
        if (Utils.equalsIgnoreCase(this.selectedRequest.process, BoardApprovalProcessConstants.ACC)) {
            service = this.sharedBoardApprovalService.getNotesForAcc(param);
        } else if (Utils.equalsIgnoreCase(this.selectedRequest.process, BoardApprovalProcessConstants.COLLECTIONS)) {
            service = this.sharedBoardApprovalService.getNotesForCollections(param);
        } else if (Utils.equalsIgnoreCase(this.selectedRequest.process, BoardApprovalProcessConstants.WF)) {
            service = this.sharedBoardApprovalService.getNotesForWorkflow(param);
        }
        this.loadingVisible = true;
        service.subscribe(
            (result: BaseProcessNotesResultDto) => {
                this.previousNotes = result.note;
                this.allowNewNotes = result.allowNewNotes;
                this.loadingVisible = false;
            },
            (error) => {
                this.loadingVisible = false;
                this.errorService.displayError(error);
            }
        );
    }
}
